export const validaFormatoSenha = new RegExp(
    "^(?=.*[A-Z])(?=.*[a-z]).{6,15}$"
);


//(?=.*[!#@$%&])(?=.*[0-9])